import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [impersonating, setImpersonating] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('lexback_token');
    const savedUser = localStorage.getItem('lexback_user');
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
    }
    if (localStorage.getItem('lexback_impersonating') === 'true') {
      setImpersonating(true);
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    // Nettoyer d'éventuels restes d'impersonation
    localStorage.removeItem('lexback_impersonating');
    localStorage.removeItem('lexback_original_token');
    localStorage.removeItem('lexback_original_user');
    setImpersonating(false);

    const res = await authAPI.login(email, password);
    const { access_token, user: userData } = res.data;
    localStorage.setItem('lexback_token', access_token);
    localStorage.setItem('lexback_user', JSON.stringify(userData));
    setUser(userData);
    return userData;
  };

  const logout = () => {
    localStorage.removeItem('lexback_token');
    localStorage.removeItem('lexback_user');
    localStorage.removeItem('lexback_impersonating');
    localStorage.removeItem('lexback_original_token');
    localStorage.removeItem('lexback_original_user');
    setUser(null);
    setImpersonating(false);
  };

  const startImpersonation = (token, userData, adminUser) => {
    // Sauvegarder la session admin
    localStorage.setItem('lexback_original_token', localStorage.getItem('lexback_token'));
    localStorage.setItem('lexback_original_user', JSON.stringify(adminUser));
    // Installer la session impersonnée
    localStorage.setItem('lexback_token', token);
    localStorage.setItem('lexback_user', JSON.stringify(userData));
    localStorage.setItem('lexback_impersonating', 'true');
    setUser(userData);
    setImpersonating(true);
  };

  const refreshUser = async () => {
    try {
      const res = await authAPI.me();
      const userData = res.data;
      localStorage.setItem('lexback_user', JSON.stringify(userData));
      setUser(userData);
      return userData;
    } catch (err) {
      // silent — fallback to cached
      return null;
    }
  };

  const stopImpersonation = () => {
    const origToken = localStorage.getItem('lexback_original_token');
    const origUser = localStorage.getItem('lexback_original_user');
    if (origToken && origUser) {
      localStorage.setItem('lexback_token', origToken);
      localStorage.setItem('lexback_user', origUser);
      setUser(JSON.parse(origUser));
    }
    localStorage.removeItem('lexback_impersonating');
    localStorage.removeItem('lexback_original_token');
    localStorage.removeItem('lexback_original_user');
    setImpersonating(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, impersonating, startImpersonation, stopImpersonation, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
